// Request bodies

export interface GetDbmssRequestBody {
  projectId: string;
}

export interface GetDbmsDetailsRequestBody {
  projectId: string;
  dbmsId: string;
}

export interface RenameDbmsRequestBody {
  projectId: string;
  dbmsId: string;
  name: string;
}

export interface UnregisterDbmsRequestBody {
  projectId: string;
  dbmsId: string;
}

// Response payloads
export interface DbmsResponse {
  dbms_id: string;
  name: string;
  status: DEPLOYMENT_STATUS;
  token_created_by: string;
}

export interface DbmsDetailsResponse extends DbmsResponse {
  edition: string;
  packaging: string;
  version: string;
  databases: Database[];
  servers: Server[];
  license?: License;
  bloom_license?: License;
  gds_license?: License;
}

export enum DEPLOYMENT_STATUS {
  RUNNING = 'running',
  DEGRADED = 'degraded',
  OFFLINE = 'offline',
  UNMONITORED = 'unmonitored',
}

export enum LICENSE_TYPE {
  FREE = 'FREE',
  COMMERCIAL = 'COMMERCIAL',
  EVALUATION = 'EVALUATION',
  UNSUPPORTED = 'UNSUPPORTED',
  INCONSISTENT = 'INCONSISTENT',
}

export enum LICENSE_STATE {
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  NOT_ACCEPTED = 'NOT_ACCEPTED',
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN',
  INCONSISTENT = 'INCONSISTENT',
}

export interface Database {
  database_id: string;
  name: string;
}

export interface Server {
  server_id: string;
  address: string;
  health: string;
  mode_constraint: string;
  version?: string;
  status: DEPLOYMENT_STATUS;
  last_ping: Date;
  database_instances: DatabaseInstance[];
  license?: License;
  bloom_license?: License;
  gds_license?: License;
}

export interface DatabaseInstance {
  database_id: string;
  database_name: string;
  role: string;
  aliases: string[];
  access: string;
  requested_status: string;
  current_status: string;
  status_message?: string;
  default: boolean;
  current_primaries_count?: number;
  current_secondaries_count?: number;
  requested_primaries_count?: number;
  requested_secondaries_count?: number;
  creation_time: Date;
  last_start_time: Date;
  store: string;
  writer: boolean;
  last_committed_txn?: number;
  replication_lag: number;
}

export interface License {
  type: LICENSE_TYPE;
  state: LICENSE_STATE;
  days_left_on_trial: number;
  total_trial_days: number;
}
